import { Button } from "@app/scripts/react-general-components/Button";
import { useSearch } from "@usereactify/search";
import { debounce } from "lodash";
import React, { useCallback } from "react";

type Props = {
  inputRef: React.MutableRefObject<HTMLInputElement | null>;
  toggleOpen: (e?: any) => void;
  clearSearch: (e?: any) => void;
  debounceTime: number;
};

export const InstantSearchForm: React.FC<Props> = ({ inputRef, toggleOpen, clearSearch, debounceTime }) => {
  const { setSearchTerm, searchTerm, submitSearchTerm, setShowInstantSearchResults } = useSearch();

  const handleSubmit = useCallback(
    (e: any) => {
      e.preventDefault();
      submitSearchTerm(searchTerm);
    },
    [submitSearchTerm, searchTerm]
  );
  const search = debounce((e) => {
    setSearchTerm(e.target?.value);
    setShowInstantSearchResults(true);
  }, debounceTime);

  return (
    <extended-search>
      <form onSubmit={handleSubmit} className="instant-search-form">
        <div className="_field">
          <input
            ref={inputRef}
            type="text"
            className="_field__input"
            onKeyUp={search}
            placeholder="Search products, categories, etc..."
            data-extendedinput
            aria-label="Search products, categories, etc..."
          />
          <button type="submit" className="_field__button left" aria-label="form button">
            <ui-icon name="icon-search" width="16" height="16"></ui-icon>
          </button>
          {searchTerm.length > 0 && (
            <Button
              onClick={clearSearch}
              label="Clear"
              ariaLabel="Clear search term"
              variant="text"
              className="instant-search-form__clear"
            />
          )}
          <button onClick={toggleOpen} type="button" className="_field__button right" aria-label="form button">
            <ui-icon name="icon-close-large" width="16" height="16"></ui-icon>
          </button>
        </div>
      </form>
      <div className="extended-search-collection visually-hidden" data-relatedcollections />
    </extended-search>
  );
};
